import api from './api';

export interface BacSkill {
  id: number;
  name: string;
  mastered: boolean;
  /** centièmes de point qu'apporte ce savoir-faire en moyenne par sujet (sujets de la série de l'élève) */
  centiemes: number;
  /** rang dans son groupe, par points décroissants (1 = le plus rentable) */
  rang: number;
}

export interface BacSkillGroup {
  title: string;
  skills: BacSkill[];
}

export interface BacSkillChapter {
  key: string;
  title: string;
  groupes: BacSkillGroup[];
}

export interface BacQuestion {
  exercice: number;
  ref: string;
  points: number;
  chapitre: string;
  skills: number[];
  ok: boolean;
}

export interface BacSujet {
  id: number;
  slug: string;
  annee: number;
  session: string;
  jour: string;
  title: string;
  total: number;
  questions: BacQuestion[];
}

export interface BacStats {
  chapitres: { key: string; title: string }[];
  mastered: number[];
  sujets: BacSujet[];
}

export interface BacPreconisation {
  id: number;
  name: string;
  chapitre: string;
  groupe: string;
  /** centièmes de point par sujet en moyenne */
  centiemes: number;
  /** cumul des centièmes depuis le premier savoir-faire de la liste */
  cumul: number;
  /** note actuelle + cumul, sur 20 */
  note_visee: number;
}

export interface BacPreconisations {
  /** note prédictive actuelle sur le sujet moyen, sur 20 */
  note: number;
  skills: BacPreconisation[];
}

/** Onglet Bac/Brevet d'un élève, vu par l'enseignant : mêmes endpoints que le portail élève, avec `student=<id>`. */
class BacStudentService {
  async getSkills(studentId: number): Promise<BacSkillChapter[]> {
    const r = await api.get('/student-portal/bac/skills/', { params: { student: studentId } });
    return r.data.chapitres;
  }

  async setMastery(studentId: number, skillId: number, mastered: boolean): Promise<void> {
    await api.post('/student-portal/bac/mastery/', { student: studentId, skill_id: skillId, mastered });
  }

  async getPreconisations(studentId: number): Promise<BacPreconisations> {
    const r = await api.get('/student-portal/bac/preconisations/', { params: { student: studentId } });
    return r.data;
  }

  async getStats(studentId: number): Promise<BacStats> {
    const r = await api.get('/student-portal/bac/stats/', { params: { student: studentId } });
    return r.data;
  }
}

const bacStudentService = new BacStudentService();
export default bacStudentService;
